import {
    VuexModule,
    Mutation,
    Action, Module
} from 'vuex-module-decorators'
import { AxiosError, AxiosResponse } from "axios";
import Vue from "vue";
import { ORSchedule, PendingShift, Event, UnavailabilityModel, DepartmentStaff, ScheduleActualCIOD, SelfScheduleDefault } from '@/models';
import router from '@/router';
import store from '@/store'
import http from '@/store/axios'

@Module({ namespaced: true })
class Schedule extends VuexModule {

    // STATE
    userSchedules: object[] = []
    acknowledge: Boolean = false
    assignmentDetail: any;
    requestDetail: any;
    selfScheduleShiftMembers: any;
    openNeedShiftMembers: any;
    pendingShiftDetails: PendingShift = new PendingShift();
    selfScheduleShiftDetails: any;
    isLoading: Boolean = true;
    potentialTradeAssignment: any;
    selfScheduleFacilities: any;
    selfScheduleDepartments: any;
    openNeedsFacilities: any;
    openNeedsDepartments: any;
    openNeedsShiftDetails: any;
    departmentSchedules: object[] = [];
    payrollDetails: object[] = [];
    defaultSelfSchedules: any;
    orAssignmentDetail: any;
    selfScheduleSkills: any;
    selfScheduleDefaultShifts: any;
    selfScheduleDefaultFacilities: any;
    selfScheduleDefaultDepartments: any;
    selfScheduleDefaultSkills: any;

    @Mutation
    public setRequestDetail(newObj: any): void {
        this.requestDetail = newObj;
    }

    @Mutation
    public setAllMySchedules(schedules: ORSchedule[]): void {
        this.userSchedules = schedules;
        this.isLoading = false;
    }
    @Mutation
    public setAcknowledge(acknowledge: boolean): void {
        this.acknowledge = acknowledge;
    }

    @Mutation
    public setAssignmentDetail(detail: any): void {
        detail.shiftMembers.length > 0 ? detail.shiftMembers.map((member) => {
            member.name = member.firstName + ' ' + member.lastName;
            return member;
        }) : '';
        detail.shift = detail.shiftCode + ' ' + detail.shiftDescription;
        this.assignmentDetail = detail;
    }

    @Mutation
    public setOpenNeedShiftMembersDetails(detail: any): void {
        detail.shiftMembers.length > 0 ? detail.shiftMembers.map((member: any) => {
            member.name = member.firstName + ' ' + member.lastName;
            return member;
        }) : '';
        this.selfScheduleShiftMembers = detail;
    }

    @Mutation
    public setSelfScheduleShiftDetails(newObj: any): void {
        newObj.map((element: any) => {
            Object.defineProperty(element, 'shiftDescription', { value: element.shiftCode + ' ' + element.shiftDescription })
            Object.defineProperty(element, 'shiftValue', { value: +element.departmentShiftId + '_' + element.departmentId })
        });

        let lastUsedShiftCode = localStorage.getItem("lastUsedShiftCode");
        if (lastUsedShiftCode != null) {
            var itemIndex = newObj.findIndex(item => item.shiftCode == lastUsedShiftCode);

            newObj.splice(
                0,                           // new index,
                0,                           // no removal
                newObj.splice(itemIndex, 1)[0] // detach the item and return it
            );
        }

        this.selfScheduleShiftDetails = newObj;
    }

    @Mutation
    public setSelfScheduleFacilities(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])
        const facilities = removeDuplicatesFromArrayByProperty(newObj, 'facilityId');
        this.selfScheduleFacilities = facilities;
    }

    @Mutation
    public setSelfScheduleSkills(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop1, prop2) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop1] === currentValue[prop1] && obj[prop2] === currentValue[prop2])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])
        const skills = removeDuplicatesFromArrayByProperty(newObj, 'skillLevelId','departmentId');
        this.selfScheduleSkills = skills;
    }

    @Mutation
    public setSelfScheduleDepartments(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        const departments = removeDuplicatesFromArrayByProperty(newObj, 'departmentId');
        this.selfScheduleDepartments = departments;
    }

    @Mutation
    public setPendingShiftDetails(newObj: PendingShift): void {
        this.pendingShiftDetails = newObj;
    }

    @Mutation
    public setOpenNeedsFacilities(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])
        const facilities = removeDuplicatesFromArrayByProperty(newObj, 'facilityId');
        this.openNeedsFacilities = facilities;
    }

    @Mutation
    public setOpenNeedsDepartments(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        const departments = removeDuplicatesFromArrayByProperty(newObj, 'departmentId');
        this.openNeedsDepartments = departments;
    }

    @Mutation
    public setOpenNeedsShiftDetails(newObj: any): void {
        newObj.map((element: any) => {
            Object.defineProperty(element, 'shiftDescription', { value: element.shiftCode + ' ' + element.shiftDescription })
            Object.defineProperty(element, 'shiftValue', { value: +element.departmentShiftId + '_' + element.departmentId })
        });
        this.openNeedsShiftDetails = newObj;
    }

    @Mutation
    public setDepartmentSchedules(schedules: DepartmentStaff[]): void {
        this.departmentSchedules = schedules;
    }

    @Mutation
    public setPayrollDetails(lstPayrollDetails: ScheduleActualCIOD[]): void {
        this.payrollDetails = lstPayrollDetails;
    }

    @Mutation
    public setDefaultSelfSchedules(schedule: any): void {
        this.defaultSelfSchedules = schedule;
    }
    @Mutation
    public setORAssignmentDetail(detail: any): void {       
        this.orAssignmentDetail = detail;
    }

    @Mutation
    public setSelfScheduleDefaultShifts(newObj: any): void {
        newObj.map((element: any) => {
            Object.defineProperty(element, 'shiftDescription', { value: element.shiftCode + ' ' + element.shiftDescription })
            Object.defineProperty(element, 'shiftValue', { value: +element.departmentShiftId + '_' + element.departmentId })
        });

        let lastUsedShiftCode = localStorage.getItem("lastUsedShiftCode");
        if (lastUsedShiftCode != null) {
            var itemIndex = newObj.findIndex(item => item.shiftCode == lastUsedShiftCode);

            newObj.splice(
                0,                           // new index,
                0,                           // no removal
                newObj.splice(itemIndex, 1)[0] // detach the item and return it
            );
        }

        this.selfScheduleDefaultShifts = newObj;
    }

    @Mutation
    public setSelfScheduleDefaultFacilities(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])
        const facilities = removeDuplicatesFromArrayByProperty(newObj, 'facilityId');
        this.selfScheduleDefaultFacilities = facilities;
    }

    @Mutation
    public setSelfScheduleDefaultSkills(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop1, prop2) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop1] === currentValue[prop1] && obj[prop2] === currentValue[prop2])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])
        const skills = removeDuplicatesFromArrayByProperty(newObj, 'skillLevelId','departmentId');
        this.selfScheduleDefaultSkills = skills;
    }

    @Mutation
    public setSelfScheduleDefaultDepartments(newObj: any): void {
        const removeDuplicatesFromArrayByProperty = (arr, prop) => arr.reduce((accumulator, currentValue) => {
            if (!accumulator.find(obj => obj[prop] === currentValue[prop])) {
                accumulator.push(currentValue);
            }
            return accumulator;
        }, [])

        const departments = removeDuplicatesFromArrayByProperty(newObj, 'departmentId');
        this.selfScheduleDefaultDepartments = departments;
    }

    // ACTIONS
    @Action({ rawError: true })
    public getAllUserSchedules(payload: any) {
        let api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/${payload.username}?index=${payload.index}`

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setAllMySchedules', res.data)
                return res
            })
            .catch((err: AxiosError) => {
                router.push('/erroraccount');
            })

    }

    @Action({ rawError: true })
    public getAssignmentDetail(payload: any) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Assignments/${payload.id}/${payload.username}`

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setAssignmentDetail', res.data);
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
    }

    @Action({ rawError: true })
    public GetRequestDetails(payload: any) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Requests/${payload.id}/${payload.username}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setRequestDetail', res.data);
                return res.data;
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public GetSelfScheduleNeedsDetails(payload: any) {        
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/SelfScheduleNeedsBySchedule/${payload.date}/${payload.username}/${payload.scheduleId}?departmentIds=${payload.departmentIds}`;
        
        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setSelfScheduleShiftDetails', JSON.parse(JSON.stringify(res?.data)));
                this.context.commit('setSelfScheduleFacilities', res.data);
                this.context.commit('setSelfScheduleDepartments', res.data);
                this.context.commit('setSelfScheduleSkills', res.data);
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public GetPendingShiftDetails(payload) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/PendingShifts/${payload.id}/${payload.username}`;

        return http
            .get(api)
            .then((res: any) => {
                console.log(res.data);
                this.context.commit('setPendingShiftDetails', res.data);
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public GetNeedsDetails(id: string, date: Date) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Needs/${date}/${id}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setNeedsDetail', res.data);
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public WithdrawEvent(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/OpenNeedRequest/${payload.needid}?assignmentId=${payload.assignementid}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public WithdrawRequestEvent(requestId: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Requests/${requestId}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                throw err;
            });
    }

    @Action({ rawError: true })
    public getShiftTradeRequested(payload: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeRequested/${payload.shiftTradeOfferId}/${payload.username}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                return res.data;
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public ScheduleOpenNeedRequest(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/OpenNeedRequest`;

        return http
            .post(apiUrl, payload)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public getOpenNeeds(data: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/OpenNeeds/${data.selectedDate}/${data.username}/${data.includePartials}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                this.openNeedShiftMembers = res;
                this.context.commit('setOpenNeedsShiftDetails', res.data);
                this.context.commit('setOpenNeedsFacilities', res.data);
                this.context.commit('setOpenNeedsDepartments', res.data);
                return res;
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public SavePendingShiftDetails(psData: PendingShift[]) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/PendingShifts`;

        return http
            .post(apiUrl, psData)
            .then((res: AxiosResponse) => {
                /*console.log(res);*/
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public RequestSchedule(psData) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Requests`;

        return http
            .post(apiUrl, psData)
            .then((res: AxiosResponse) => {
                /*console.log(res);*/
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public DeletePendingShiftDetails(payload) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/PendingShifts/${payload.id}/${payload.username}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public SaveUnavailabilityDetails(uaData: UnavailabilityModel[]) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Unavailabilities`;

        return http
            .post(apiUrl, uaData)
            .then((res: AxiosResponse) => {
                /*console.log(res);*/
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public DeleteUnavailabilityDetails(id: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Unavailabilities/${id}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public getShiftTradeOffer(payload: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers/${payload.shiftTradeOfferId}/${payload.username}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                return res;
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public createShiftTradeOffers(payload: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers`;

        return http
            .post(apiUrl, payload)
            .then((res) => {
                return res;
            })
            .catch((err: AxiosError) => {
                throw err;
            });
    }

    @Action({ rawError: true })
    public deleteShiftTradeOffer(payload: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers/${payload.shiftTradeOfferId}/${payload.username}`;

        return http
            .delete(apiUrl)
            .then()
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public acceptShiftTradeOffer(payload: object) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers`;

        return http
            .post(apiUrl, payload)
            .then()
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public getPotetialTradeAssignment(payload: any) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers/PotentialTrades/${payload.assignmentId}?currentPage=${payload.currentPage}&pageSize=6&autoApprovableOnly=${payload.autoApprovableOnly}&searchFirstNameLike=${payload.searchFirstNameLike}&searchLastNameLike=${payload.searchLastNameLike}&searchStartDate=${payload.searchStartDate}&searchEndDate=${payload.searchEndDate}&primaryDeptOnly=${payload.primaryDeptOnly}`;

        return http
            .get(apiUrl)
            .then((res: AxiosResponse) => {
                return res.data;
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

    @Action({ rawError: true })
    public withdrawPotentialTrade(shiftTradeOfferId: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/ShiftTradeOffers/${shiftTradeOfferId}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
                return res;
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public SubmitCommitmentDetails(scheduleId: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/PendingShifts/${scheduleId}`;

        return http
            .post(apiUrl)
            .then((res: AxiosResponse) => {
                /*console.log(res);*/
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public SaveSelfScheduleAsAssignment(assignmentData: any[]) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Assigment`;

        return http
            .post(apiUrl, assignmentData)
            .then((res: AxiosResponse) => {
                /*console.log(res);*/
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public DeleteSelfScheduleAssignment(assignmentId: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Assigment/${assignmentId}`;

        return http
            .delete(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public GetScheduleAssignmentDetail(payload: any) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/Assignments/${payload.id}/${payload.username}`

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setAssignmentDetail', res.data);
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })
    }

    @Action({ rawError: true })
    public getDepartmentSchedule(payload: any){
        let api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/DepartmentSchedules/${payload.deptId}/${payload.startDate}/${payload.endDate}/${payload.username}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setDepartmentSchedules', res.data)
                return res
            })
            .catch((err: AxiosError) => {
                console.log(err)
            })

    }

    // ACTIONS
    @Action({ rawError: true })
    public getPayrollDetails(payload: any){
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/PayrollDetails/${payload.startDate}/${payload.endDate}/${payload.username}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit("setPayrollDetails", res.data);
                return res;
            })
            .catch((err: AxiosError) => {
                console.log(err);
            });
    }

    // ACTIONS
    @Action({ rawError: true })
    public getDefaultSelfSchedules(payload) {
        let api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/DefaultSchedules/${payload.username}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setDefaultSelfSchedules', res.data)
                return res
            })
            .catch((err: AxiosError) => {
                router.push('/erroraccount');
            })

    }

    @Action({ rawError: true })
    public saveDefaultSelfSchedules(ssdData: SelfScheduleDefault){
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/DefaultSchedules`;

        return http
            .post(apiUrl, ssdData)
            .then((res: AxiosResponse) => {
                this.context.commit("setDefaultSelfSchedules", ssdData);
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }

    @Action({ rawError: true })
    public UpdateDefaultSelfScheduleAppliedStatus(scheduleId: string) {
        const apiUrl = `${process.env.VUE_APP_BASE_API_URL}/Schedules/DefaultSchedules/DefaultSelfScheduleApplied/${scheduleId}`;

        return http
            .post(apiUrl)
            .then((res: AxiosResponse) => {
            })
            .catch((err: AxiosError) => {
                console.log(err)
                throw err;
            });
    }
    @Action({ rawError: true })
    public getORAssignmentDetails(payload: any) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Symphony/Procedures/${payload.date}/${payload.username}`

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setORAssignmentDetail', res.data);
                return res
            })
            .catch((err: AxiosError) => {               
                 console.log(err)                
            })
    }

    @Action({ rawError: true })
    public getSelfScheduleDefaultShifts(payload: any) {
        const api = `${process.env.VUE_APP_BASE_API_URL}/Schedules/DefaultSchedules/ShiftDetails/${payload.date}/${payload.username}?departmentIds=${payload.departmentIds}`;

        return http
            .get(api)
            .then((res: any) => {
                this.context.commit('setSelfScheduleDefaultShifts', JSON.parse(JSON.stringify(res?.data)));  
                this.context.commit('setSelfScheduleDefaultFacilities', res.data);
                this.context.commit('setSelfScheduleDefaultDepartments', res.data);
                this.context.commit('setSelfScheduleDefaultSkills', res.data);              
            })
            .catch((err: AxiosError) => {
                console.log(err)
            });
    }

}
export default Schedule